export const MAX_TAB_SIZE = '13rem'
